module.exports = __webpack_public_path__ + "img/collection-engagementRingsPrincess@2x.2ae95ae.jpg";